import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useLanguage } from "@/context/LanguageContext";

export default function AdminLogin() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ope_admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6" data-testid="admin-login-page">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md bg-secondary/40 border border-border p-10">
        <Link to="/" className="block text-center font-heading text-3xl mb-2">Our Promise <span className="italic">Events</span></Link>
        <p className="text-xs tracking-[0.3em] uppercase text-gold mb-10 text-center">{t("admin.loginTitle")}</p>
        <div className="space-y-6">
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-ink-muted mb-2 block">{t("admin.email")}</label>
            <input type="email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full border-b border-border bg-transparent py-3 focus:outline-none focus:border-ink" />
          </div>
          <div>
            <label className="text-xs tracking-[0.2em] uppercase text-ink-muted mb-2 block">{t("admin.password")}</label>
            <input type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full border-b border-border bg-transparent py-3 focus:outline-none focus:border-ink" />
          </div>
        </div>
        <button type="submit" data-testid="admin-login-submit" disabled={loading} className="mt-10 w-full bg-ink text-cream py-4 text-[11px] tracking-[0.3em] uppercase hover:bg-gold transition-colors disabled:opacity-60">
          {loading ? "…" : t("admin.login")}
        </button>
      </form>
    </div>
  );
}
